import { SET_SYSTEM_PRICE } from './constants';

const defaultState = {
    cashprice: null,
};

const resultsUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SYSTEM_PRICE:
            return { ...state, cashprice: action.cashprice };

        default:
            return state;
    }
};

export default resultsUI;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/reducer.js